import { css } from 'react-emotion'

export const answerInput = css`
  height: 40px;
  opacity: 0.4;
  background-color: #f7f9fa;
  border-radius: 4px;
  border-style: solid;
  border-color: #8394a3;
  border-width: 1px;
`



// WEBPACK FOOTER //
// ./src/styles/inputs.js